import { produce } from "immer";
import _ from "lodash";
import { mergeWithArrays } from "src/util/functions";
import {
  tCompanyAction,
  tCompanyState,
  tSetCompany,
  tUpdateBrandEthos,
  tUpdateHeroImages,
  tUpdateSettings,
} from "./types";

const handleUpdate = (state: tCompanyState, action: tUpdateSettings): tCompanyState => {
  return mergeWithArrays<tCompanyState>(state, "CONCAT", action.settingsPart);
};

const handleUpdateBrandEthos = (state: tCompanyState, action: tUpdateBrandEthos): tCompanyState => {
  if (state.type === "brand") {
    if (state.brandEthos.includes(action.toggle)) {
      state.brandEthos = state.brandEthos.filter((a) => a !== action.toggle);
      return state;
    }
    state.brandEthos.push(action.toggle);
    return state;
  }
  return state;
};

const handleUpdateHeroImages = (state: tCompanyState, action: tUpdateHeroImages): tCompanyState => {
  if (state.type === "brand") {
    while (state.images.heroes.length < action.imageIndex + 1) {
      state.images.heroes.push({ downloadURL: "", isPrimary: false });
    }
    state.images.heroes[action.imageIndex].downloadURL = action.image;
    return state;
  }
  return state;
};

const handleSetCompany = (action: tSetCompany): tCompanyState => {
  return action.company;
};

const handleReset = (): tCompanyState => {
  return { type: "none" };
};

// Inspiration from: https://adostes.medium.com/simplify-redux-reducers-with-immer-9a3638229d45
export const CompanyReducer = produce(
  (draft: tCompanyState = { type: "none" }, action: tCompanyAction): tCompanyState => {
    switch (action.type) {
      case "UPDATE_CONTACT_SETTINGS":
        return handleUpdate(draft, action);
      case "UPDATE_BRAND_SETTINGS":
        return handleUpdate(draft, action);
      case "UPDATE_BRAND_PROMOTIONS":
        if (draft.type === "brand") draft.promotions = action.settingsPart;
        return draft;
      case "UPDATE_REP_SETTINGS":
        return handleUpdate(draft, action);
      case "UPDATE_RETAIL_SETTINGS":
        return handleUpdate(draft, action);
      case "UPDATE_BRAND_ETHOS":
        return handleUpdateBrandEthos(draft, action);
      case "UPDATE_HERO_IMAGES":
        return handleUpdateHeroImages(draft, action);
      case "SET_COMPANY":
        return handleSetCompany(action);
      case "RESET_SETTINGS":
        return handleReset();
      default:
        return draft;
    }
  },
);
